import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as orderActions from '../../../actions/orderActions';

class OrderButton extends React.Component {
  render () {
    const {orderActions} = this.props;
    return (
      <button className="btn btn-primary" onClick={orderActions.showModal}>Zamów</button>
    );
  }
}

OrderButton.propTypes = {
  orderActions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    orderActions: bindActionCreators(orderActions, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(OrderButton);



// WEBPACK FOOTER //
// ./src/components/common/OrderButton/OrderButton.js